import { cs } from "../../utils/currency";
import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

interface PaymentBreakdownChartProps {
  data: Array<{
    method: string;
    amount: number;
  }>;
}

const COLORS = ["#2563eb", "#93c5fd", "#16a34a", "#9333ea", "#f59e0b", "#64748b"];

// Card payments may come back as "stripe" from older APIs; both are Square.
// e.g. "bonus_wallet" -> "BONUS WALLET"
export const formatPaymentMethod = (method: string) =>
  (method === "stripe" ? "square" : String(method)).replace(/_/g, " ").toUpperCase();

const PaymentBreakdownChart: React.FC<PaymentBreakdownChartProps> = ({ data }) => {
  return (
    <div className="h-[280px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data
              .filter((entry) => entry.amount > 0)
              .map((entry) => ({ ...entry, method: formatPaymentMethod(entry.method) }))}
            dataKey="amount"
            nameKey="method"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={90}
            label={({ method }) => method}
          >
            {data.filter((entry) => entry.amount > 0).map((entry, index) => (
              <Cell key={`${entry.method}-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => `${cs()}${Number(value).toFixed(2)}`} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PaymentBreakdownChart;
